import { NgModule } from '@angular/core';
import { AnonymousConsentsModule, AuthModule, CONFIG_INITIALIZER, ConfigInitializer, CostCenterOccModule, ExternalRoutesModule, ProductModule, ProductOccModule, provideFeatureToggles, UserModule, UserOccModule } from "@spartacus/core";
import { OrderHistoryModule } from '@spartacus/order/components';
import { OrderCoreModule } from '@spartacus/order/core';
import { OrderOccModule } from '@spartacus/order/occ';
import { AnonymousConsentManagementBannerModule, AnonymousConsentsDialogModule, BannerCarouselModule, BannerModule, BreadcrumbModule, CategoryNavigationModule, ConsentManagementModule, FooterNavigationModule, HamburgerMenuModule, HomePageEventModule, LinkModule, LoginRouteModule, LogoutModule, MyCouponsModule, MyInterestsModule, NavigationEventModule, NavigationModule, NotificationPreferenceModule, PageTitleModule, PaymentMethodsModule, PDFModule, ProductCarouselModule, ProductDetailsPageModule, ProductFacetNavigationModule, ProductImagesModule, ProductIntroModule, ProductListingPageModule, ProductListModule, ProductPageEventModule, ProductSummaryModule, ProductTabsModule, ScrollToTopModule, SearchBoxModule, SiteContextSelectorModule, StockNotificationModule, TabParagraphContainerModule, VideoModule } from "@spartacus/storefront";
import { AddressBookModule } from "@spartacus/user/profile/components";
import { AirdiskBrakeModule } from '../customcomponents/AirDisk-brake/airdisk-brake.module';
import { KbBreadcrumbModule } from '../customcomponents/category-page/breadcrumb/breadcrumb.module';
import { KbContactUsFormModule } from '../customcomponents/contact-us-form/contact-us-form.module';
import { CountrySelectorModule } from '../customcomponents/country-selector/country-selector.module';
import { EndasureModule } from '../customcomponents/endasure/endasure.module';
import { KbAddToCartModule } from '../customcomponents/kb-add-to-cart/kb-add-to-cart.module';
import { KbAsmComponentsModule } from '../customcomponents/kb-asm-components/kb-asm-components.module';
import { KbCartDetailsModule } from '../customcomponents/kb-cart/kb-cart-details/kb-cart-details.module';
import { KbCookiesModule } from '../customcomponents/kb-cookies-page/kb-cookies/kb-cookies.module';
import { KbCustomDocumentSearchModule } from '../customcomponents/kb-CustomDocumentSearchTab/kbCustomDocumentSearch.module';
import { KbCustomSoftWareSearchModule } from '../customcomponents/kb-CustomSoftwareSearch/kbCustomSoftwareSearch.module';
import { KbDtcSearchModule } from '../customcomponents/kb-dtc-search/kb-dtc-search.module';
import { KbFooterNavigationModule } from '../customcomponents/kb-footer-navigation/kb-footer-navigation.module';
import { KbFormulaBlueModule } from '../customcomponents/kb-formula-blue/kb-formula-blue.module';
import { KbGetAQuote } from '../customcomponents/kb-Get-A-Quote/kbGetAQuote.module';
import { KbSecurePasswordModule } from '../customcomponents/kb-login/kb-secure-password/kb-secure-password.module';
import { KbMyQuotesModule } from '../customcomponents/kb-my-quotes/kb-my-quotes.module';
import { KbMyOrdersModule } from '../customcomponents/kb-myAccount/kb-MyOrders/kbMyOrder.module';
import { KbMyCompanyAccountModule } from '../customcomponents/kb-mycompany-account/kb-myCompany-account.module';
import { KbMyCoresModuleNA } from '../customcomponents/kb-MyCoresNA/KbMyCoresModuleNA.module';
import { KbNavigationUiModule } from '../customcomponents/kb-navigation-ui/kb-navigation-ui.module';
import { KbOrderStatusModule } from '../customcomponents/kb-order-status/kb-order-status.module';
import { KbPaginationModule } from '../customcomponents/kb-pagination/kb-pagination/kb-pagination.module';
import { KbParagraphModule } from '../customcomponents/kb-paragraph/kb-paragraph.module';
import { KbProductDetailsModule } from '../customcomponents/kb-product-details/kb-product-details.module';
import { KbCrossRefGridItemModule } from '../customcomponents/kb-product-list/kb-cross-ref-grid-item/kb-cross-ref-grid-item.module';
import { KbCrossRefModule } from '../customcomponents/kb-product-list/kb-cross-ref/kb-cross-ref-list-item.module';
import { KbProductGridItemModule } from '../customcomponents/kb-product-list/kb-product-grid-item/kb-product-grid-item.module';
import { KbProductListItemModule } from '../customcomponents/kb-product-list/kb-product-list-item/kb-product-list-item.module';
import { KbProductListModule } from '../customcomponents/kb-product-list/kb-product-list/kb-product-list.module';
import { KbSoftwareGridItemModule } from '../customcomponents/kb-product-list/kb-software-grid-item/kb-software-grid-item.module';
import { KbSoftwareListItemModule } from '../customcomponents/kb-product-list/kb-software-list-item/kb-software-list-item.module';
import { KbRegisterModule } from '../customcomponents/kb-register/kb-register.module';
import { KbSavedShoppingCartModule } from '../customcomponents/kb-saved-shopping-cart/kb-saved-shopping-cart.module';
import { SteeringGearModule } from '../customcomponents/kb-steering-gear/steering-gear/steering-gear.module';
import { SmartireRoiModule } from '../customcomponents/smartire-roi/smartire-roi.module';
import { KbStoreFinderModule } from '../customcomponents/store-finder/kb-store-finder/kb-store-finder.module';
import { AsmCustomer360FeatureModule } from './features/asm/asm-customer-360-feature.module';
import { AsmFeatureModule } from './features/asm/asm-feature.module';
import { CartBaseFeatureModule } from './features/cart/cart-base-feature.module';
import { CartImportExportFeatureModule } from './features/cart/cart-import-export-feature.module';
import { CartQuickOrderFeatureModule } from './features/cart/cart-quick-order-feature.module';
import { CartSavedCartFeatureModule } from './features/cart/cart-saved-cart-feature.module';
import { WishListFeatureModule } from './features/cart/wish-list-feature.module';
import { CheckoutFeatureModule } from './features/checkout/checkout-feature.module';
import { OrderFeatureModule } from './features/order/order-feature.module';
import { ProductImageZoomFeatureModule } from './features/product/product-image-zoom-feature.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';
import { StoreFinderFeatureModule } from './features/storefinder/store-finder-feature.module';
import { PersonalizationFeatureModule } from './features/tracking/personalization-feature.module';
import { UserFeatureModule } from './features/user/user-feature.module';
import { KbNotificationsModule } from '../customcomponents/kb-Notifications/kb-notifications/kb-notifications.module';
import { KbSmartTireModule } from '../customcomponents/kb-smartTire/kb-smart-tire/kb-smart-tire.module';
import { EnvironmentService } from '../services/environment.service';

@NgModule({
  declarations: [],
  imports: [
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    KbParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,
    ScrollToTopModule,
    PageTitleModule,
    VideoModule,
    PDFModule,
    UserModule,
    UserOccModule,
    AddressBookModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    StockNotificationModule,
    ConsentManagementModule,
    MyCouponsModule,
    AnonymousConsentsModule.forRoot(),
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,
    ProductModule.forRoot(),
    ProductOccModule,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductListModule,
    SearchBoxModule,
    ProductFacetNavigationModule,
    ProductTabsModule,
    ProductCarouselModule,
    ProductImagesModule,
    ProductSummaryModule,
    ProductIntroModule,
    CostCenterOccModule,
    NavigationEventModule,
    HomePageEventModule,
    ProductPageEventModule,
    ExternalRoutesModule.forRoot(),
    UserFeatureModule,
    CartBaseFeatureModule,
    CartSavedCartFeatureModule,
    WishListFeatureModule,
    CartQuickOrderFeatureModule,
    CartImportExportFeatureModule,
    OrderFeatureModule,
    CheckoutFeatureModule,
    PersonalizationFeatureModule,
    StoreFinderFeatureModule,
    SmartEditFeatureModule,
    ProductImageZoomFeatureModule,
    AsmFeatureModule,
    AsmCustomer360FeatureModule,
    KbRegisterModule,
    CountrySelectorModule,
    KbNavigationUiModule,
    KbFooterNavigationModule,
    KbProductListModule,
    KbProductGridItemModule,
    KbProductListItemModule,
    KbAddToCartModule,
    KbCrossRefModule,
    KbCrossRefGridItemModule,
    KbSoftwareGridItemModule,
    KbSoftwareListItemModule,
    KbBreadcrumbModule,
    KbProductDetailsModule,
    KbCartDetailsModule,
    KbContactUsFormModule,
    KbStoreFinderModule,
    SmartireRoiModule,
    KbSmartTireModule,
    KbMyCompanyAccountModule,
    KbMyCoresModuleNA,
    KbCustomDocumentSearchModule,
    KbMyOrdersModule,
    SteeringGearModule,
    KbFormulaBlueModule,
    KbOrderStatusModule,
    KbSavedShoppingCartModule,
    EndasureModule,
    AirdiskBrakeModule,
    KbCustomSoftWareSearchModule,
    OrderCoreModule,
    OrderOccModule,
    OrderHistoryModule,
    KbGetAQuote,
    KbMyQuotesModule,
    KbSecurePasswordModule,
    KbAsmComponentsModule,
    KbCookiesModule,
    KbDtcSearchModule,
    KbPaginationModule,
    KbNotificationsModule
  ],
  providers: [
    { provide: CONFIG_INITIALIZER, useFactory: authConfig, deps: [EnvironmentService], multi: true },
    provideFeatureToggles({
      authorizationCodeFlowByDefault: true,
      incrementProcessesCountForMergeCart: true,
      dispatchLoginActionOnlyWhenTokenReceived: true,
      enablePasswordExpiredErrorTranslation: true,
      cdsLoginEventsToken: true,
      //a11yNavigationButtonsAriaFixes: false
    }),
  ],
})
export class SpartacusFeaturesModule { }
export function authConfig(envService: EnvironmentService): ConfigInitializer {
  return {
    scopes: ['authentication'],
    async configFactory() {
      const env = envService.getConfig();
      return {
        authentication: {
          client_id: 'mobile_android_na',
          client_secret: '',
          useClientTokens: true,
          OAuthLibConfig: {
            redirectUri: env.naStoreUrl
          },
        },
      };
    },
  };
}